import api from '@/API';
import { PostPlatformCategoryFilter, Report, ReportFormatOptions } from '@/type';
import { ReportGenerated, ReportDeleted } from '@/messaging/events';
import eventBus from '@/messaging/event-bus';

export function generate(
  clientId: number, type: string, name: string, statuses: number[], isInclusive: boolean,
  socialSiteIds: number[], isOnTimeline?: boolean, isFlagged?: boolean, mediaTypes?: string[],
  personIds?: number[], startDate?: string|null, endDate?: string|null,
  categoryIds?: PostPlatformCategoryFilter,
): Promise<Report> {
  const url = `clients/${clientId}/reports`;
  return api
    .post(url, {
      type,
      name,
      statuses,
      isOnTimeline,
      isFlagged,
      isInclusive,
      socialSiteIds,
      mediaTypes,
      personIds,
      startDate,
      endDate,
      categoryIds,
    })
    .then((response) => {
      const r = (response.data as Report);
      eventBus.$emit(ReportGenerated.eventName, new ReportGenerated(r.id));
      return r;
    });
}

export function deleteAll(ids: number[]): Promise<void> {
  return api
    .delete('reports', { data: { ids } })
    .then(() => {
      ids.forEach((id) => {
        eventBus.$emit(ReportDeleted.eventName, new ReportDeleted(id));
      });
    });
}

export function download(
  reportId: number,
  format: string,
  formatOptions: ReportFormatOptions,
): Promise<void> {
  return api.post(`reports/${reportId}/${format}`, { formatOptions });
}
